module.exports = __webpack_public_path__ + "static/media/LOGO-SHOP.1f9afb42.jpg";